import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "title"
}
const _hoisted_2 = { class: "content" }

import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import store from "@/store";

import { toast } from "@/common/utils/toast";

import {
  evaluationCrewList,
  evaluationCrewCreate,
  evaluationCrewDelete,
} from "@/common/api/rest/evaluation/crew";

import type { EvaluationType } from "@/common/types/evaluation";
import type { EvaluationCrewListType } from "@/common/types/evaluation/crew";

import { searchCrew } from "@/components";
import { baseConfirm, baseModal, baseTable } from "@/common/components";

interface SelectCrewType {
  member_id: string;
  name: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'crew',
  props: {
    data: {},
    width: { default: "100%" },
    showTitle: { type: Boolean, default: true },
    isEdit: { type: Boolean, default: true }
  },
  emits: ["update-data"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const emit = __emit;

const props = __props;

const tableHeader = computed(() => [
  { key: "name", label: t("common.labels.name") },
  { key: "type", label: t("common.labels.type") },
]);

const tableData = ref<EvaluationCrewListType[]>([]);

const selected = ref<EvaluationCrewListType>(null);
const selectedCrew = ref<EvaluationCrewListType[]>([]);

const limit = ref<number>(10);
const page = ref<number>(0);
const pages = ref<number>(0);
const search = ref<string>("");
const searched = ref<number>(0);
const total = ref<number>(0);

const showModalAdd = ref(false);
const showConfirmDel = ref(false);

function fetchData() {
  if (!props.data) return;

  evaluationCrewList(props.data.account_id, {
    evaluation_id: props.data.evaluation_id,
    limit: limit.value,
    page: page.value,
    search: search.value,
  })
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        tableData.value = data.list;
        page.value = data.infos.page;
        pages.value = data.infos.pages;
        total.value = data.infos.total;
        searched.value = data.infos.count;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function update() {
  emit("update-data");
}

function add() {
  showModalAdd.value = true;
  selectedCrew.value = [];
}

function addCancel() {
  selectedCrew.value = [];
  showModalAdd.value = false;
}

function addSelect(data: EvaluationCrewListType[]) {
  selectedCrew.value = data;
}

function addConfirm() {
  if (!props.data || !selectedCrew.value.length) return;

  showModalAdd.value = false;

  const promises = selectedCrew.value.map((sl) =>
    evaluationCrewCreate(props.data.account_id, {
      evaluation_id: props.data.evaluation_id,
      member_id: sl.member_id,
      name: sl.name,
      type: sl.type,
    }),
  );

  Promise.all(promises)
    .then((responses) => {
      responses.forEach((response) => {
        const { success, message } = response;
        if (success) {
          toast({ message: message, type: "success" });
          update();
          fetchData();
        } else {
          toast({ message: message, type: "error" });
        }
      });
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function remove(data: EvaluationCrewListType) {
  selected.value = data;
  showConfirmDel.value = true;
}

function searchItem(value: string) {
  search.value = value;
  fetchData();
}

function removeCancel() {
  selected.value = null;
  showConfirmDel.value = false;
}

function removeConfirm() {
  if (!selected.value) return;

  store.commit("SET_LOADING", true);

  evaluationCrewDelete(props.data.account_id, selected.value.item_id)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchData();
        removeCancel();
        update();
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      store.commit("SET_LOADING", false);
    });
}

function changePage(value: number) {
  page.value = value;
  fetchData();
}

onMounted(() => {
  fetchData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["tab-component", { width: __props.width }])
  }, [
    (__props.showTitle)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(t)("common.labels.crew")), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(baseTable), {
        header: tableHeader.value,
        data: tableData.value,
        limit: limit.value,
        page: page.value,
        pages: pages.value,
        total: total.value,
        searched: searched.value,
        options: true,
        add: __props.isEdit,
        del: __props.isEdit,
        "onChange:page": changePage,
        onSearching: searchItem,
        "onBtn:add": _cache[0] || (_cache[0] = ($event: any) => (add())),
        "onBtn:del": remove
      }, {
        name: _withCtx(({ data }) => [
          _createElementVNode("span", null, _toDisplayString(data.name), 1)
        ]),
        type: _withCtx(({ data }) => [
          _createElementVNode("span", null, _toDisplayString(_unref(t)(`technical.types.${data.type}`)), 1)
        ]),
        _: 1
      }, 8, ["header", "data", "limit", "page", "pages", "total", "searched", "add", "del"])
    ]),
    _createVNode(_unref(baseConfirm), {
      show: showConfirmDel.value,
      title: 
        _unref(t)('common.labels.remove', {
          concat: _unref(t)('common.labels.technical'),
        }).toUpperCase()
      ,
      message: 
        _unref(t)('common.texts.remove_message', {
          concat: selected.value?.name,
        })
      ,
      onCancel: removeCancel,
      onConfirm: removeConfirm
    }, null, 8, ["show", "title", "message"]),
    _createVNode(_unref(baseModal), {
      show: showModalAdd.value,
      title: 
        _unref(t)('common.labels.add', {
          concat: _unref(t)('common.labels.technical'),
        }).toUpperCase()
      ,
      "show-button-confirm": true,
      "button-confirm": _unref(t)('common.labels.add'),
      "button-close": _unref(t)('common.labels.cancel'),
      onClose: _cache[1] || (_cache[1] = ($event: any) => (addCancel())),
      onConfirm: _cache[2] || (_cache[2] = ($event: any) => (addConfirm()))
    }, {
      content: _withCtx(() => [
        _createVNode(_unref(searchCrew), {
          account_id: __props.data?.account_id,
          ids: tableData.value?.map((item) => item.member_id),
          onUpdateData: addSelect
        }, null, 8, ["account_id", "ids"])
      ]),
      _: 1
    }, 8, ["show", "title", "button-confirm", "button-close"])
  ], 2))
}
}

})